import React, { Component} from 'react';
import PropTypes from "prop-types";
import { Translation } from 'react-i18next';

import { connect } from "react-redux";
import {
  fetchCryptoLinksList,
  applyCryptoLinkDrag,
  clearCreateCryptoLink,
  clearPatchCryptoLink,
  clearDeleteCryptoLink,
  clearCryptoLinkDrag,
} from 'redux/crypto-links/actions';
import { resetLastPatchedId } from 'redux/common/actions';

import {
  DragDropContext,
  Droppable,
  Draggable,
} from "react-beautiful-dnd";
import { Loader } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

import CryptoLinksListItem
  from 'components/dashboard/crypto-links-content/CryptoLinksListItem';
import CryptoLinksEmptyPlaceholder
  from 'components/dashboard/crypto-links-content/CryptoLinksEmptyPlaceholder';
import CommonMessage from 'components/common/CommonMessage';

import './CryptoLinksList.css';


class CryptoLinksList extends Component {
  static propTypes = {
    fetchCryptoLinksList: PropTypes.func.isRequired,
    applyCryptoLinkDrag: PropTypes.func.isRequired,
    clearCreateCryptoLink: PropTypes.func.isRequired,
    clearPatchCryptoLink: PropTypes.func.isRequired,
    clearDeleteCryptoLink: PropTypes.func.isRequired,
    clearCryptoLinkDrag: PropTypes.func.isRequired,
    resetLastPatchedId: PropTypes.func.isRequired,
    cryptoServicesList: PropTypes.arrayOf(PropTypes.shape),
    cryptoLinksList: PropTypes.arrayOf(PropTypes.shape),
    cryptoLinksListError: PropTypes.object,
    createCryptoLinkSuccess: PropTypes.object,
    patchCryptoLinkSuccess: PropTypes.object,
    deleteCryptoLinkSuccess: PropTypes.object,
    cryptoLinkDrugSuccess: PropTypes.object,
    me: PropTypes.object,
  };

  static defaultProps = {
    me: null,
    cryptoServicesList: null,
    cryptoLinksList: null,
    cryptoLinksListError: null,
    createCryptoLinkSuccess: null,
    patchCryptoLinkSuccess: null,
    deleteCryptoLinkSuccess: null,
    cryptoLinkDrugSuccess: null,
  };

  state = {
    items: null,
  };

  componentDidMount() {
    this.setState({ items: this.props.cryptoLinksList });
  }

  componentDidUpdate(prevProps) {
    // Set Current List
    if (prevProps.cryptoLinksList !== this.props.cryptoLinksList) {
      this.setState({ items: this.props.cryptoLinksList });
    }

    // Create
    if (
      !prevProps.createCryptoLinkSuccess &&
      prevProps.createCryptoLinkSuccess !== this.props.createCryptoLinkSuccess
    ) {
      this.props.fetchCryptoLinksList();
      this.props.clearCreateCryptoLink();
    }

    // Patch
    if (
      !prevProps.patchCryptoLinkSuccess &&
      prevProps.patchCryptoLinkSuccess !== this.props.patchCryptoLinkSuccess
    ) {
      this.props.fetchCryptoLinksList();
      this.props.clearPatchCryptoLink();
      this.props.resetLastPatchedId();
    }

    // Delete
    if (
      !prevProps.deleteCryptoLinkSuccess &&
      prevProps.deleteCryptoLinkSuccess !== this.props.deleteCryptoLinkSuccess
    ) {
      this.props.fetchCryptoLinksList();
      this.props.clearDeleteCryptoLink();
    }

    // Drag
    if (
      !prevProps.cryptoLinkDrugSuccess &&
      prevProps.cryptoLinkDrugSuccess !== this.props.cryptoLinkDrugSuccess
    ) {
      this.props.fetchCryptoLinksList();
      this.props.clearCryptoLinkDrag();
    }
  }

  componentWillUnmount() {
    this.props.resetLastPatchedId();
  }

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  onDragEnd = result => {
    if (!result.destination) {
      return;
    }

    const items = this.reorder(
      this.state.items,
      result.source.index,
      result.destination.index
    );

    this.setState({ items }, () => {
      const form = new FormData();
      this.state.items.map(item => item.id)
        .forEach(item => form.append('order', item));
      this.props.applyCryptoLinkDrag(form);
    });
  };

  renderCryptoLinksList = () => {
    const { items } = this.state;

    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable">
          {provided => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {items && items.map((item, index) => (
                <Draggable
                  key={`${item.id}`}
                  draggableId={`${item.id}`}
                  index={index}
                >
                  {provided => (
                    <div
                      className="list-wrapper"
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <CryptoLinksListItem
                        key={`crypto-link-list-item-key-${item.id}`}
                        item={item}
                      />
                    </div>
                  )}
                </Draggable>
              ))}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  };

  render() {
    const { me, cryptoLinksList, cryptoLinksListError } = this.props;
    const { items } = this.state;

    if (cryptoLinksList && cryptoLinksList.length === 0) {
      return <CryptoLinksEmptyPlaceholder />;
    }

    return (
      <Translation>
        {(t) => (
          <div className="crypto-links-list__component">
            <div className="title-wrapper">
              <div className="title">{t("CRYPTO LINKS")}</div>
              {(me && me.subscription && !me.subscription.ff_social_links_custom_label) ?
                <div className="text-wrapper">
                  <div className="icon-lock" />
                  <div className="text">
                    {t("You can change the title of any Crypto Link on the")} <strong>PRO</strong> {t("plan")}.
                    {t("Upgrade")} <Link to="/billing">{t("here")}</Link>
                  </div>
                </div>
                :
                <div className="text-wrapper">
                  <div className="text">
                    {t("You are")} <strong>PRO</strong>! {t("You can add QR code to your crypto address")}
                  </div>
                </div>
              }
            </div>

            {/* Loader */}
            {!cryptoLinksList && !cryptoLinksListError &&
              <Loader active />
            }

            {/* Crypto Links List */}
            {items && items.length > 0 && this.renderCryptoLinksList()}

            {/* Crypto Links Error */}
            {cryptoLinksListError &&
              <CommonMessage
                error
                errors={cryptoLinksListError}
              />
            }
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    cryptoServicesList: state.cryptoLinksReducer.cryptoServicesList,
    cryptoLinksList: state.cryptoLinksReducer.cryptoLinksList,
    cryptoLinksListError: state.cryptoLinksReducer.cryptoLinksListError,
    createCryptoLinkSuccess: state.cryptoLinksReducer.createCryptoLinkSuccess,
    patchCryptoLinkSuccess: state.cryptoLinksReducer.patchCryptoLinkSuccess,
    deleteCryptoLinkSuccess: state.cryptoLinksReducer.deleteCryptoLinkSuccess,
    cryptoLinkDrugSuccess: state.cryptoLinksReducer.cryptoLinkDrugSuccess,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchCryptoLinksList,
    applyCryptoLinkDrag,
    clearCreateCryptoLink,
    clearPatchCryptoLink,
    clearDeleteCryptoLink,
    clearCryptoLinkDrag,
    resetLastPatchedId,
  },
)(CryptoLinksList);
